import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from 'react-query';

import 'react-toastify/dist/ReactToastify.css';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import 'leaflet/dist/leaflet.css';

import store from './support/store';
import Routes from './routes';

import Catcher from './support/services/catcher';
import { Crash } from './flow/pages';

import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: 1000 * 60 * 5,
      staleTime: 1000 * 60 * 5,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <Catcher FallbackComponent={Crash}>
          <Routes />
          <ToastContainer autoClose={4000} pauseOnFocusLoss newestOnTop closeOnClick={false} limit={1}/>
        </Catcher>
      </QueryClientProvider>
    </ReduxProvider>
  );
}

export default App;
